import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';

export interface BeBuildMetadata {
  buildData: string;
  isProduction: boolean;
}

export enum ConfigurationStructureKey {
  GoogleSheetAccountEmail = 'GoogleSheetAccountEmail',
  SupportedCustomProductFeedClients = 'SupportedCustomProductFeedClients',
  SupportedCustomLocationFeedClients = 'SupportedCustomLocationFeedClients',
  BEBuildMetadata = 'BEBuildMetadata',
}

/*
 * Please add only attributes that extends ConfigurationStructureKey
 */
export interface ConfigurationStructure {
  [ConfigurationStructureKey.GoogleSheetAccountEmail]: string;
  [ConfigurationStructureKey.SupportedCustomProductFeedClients]: number[];
  [ConfigurationStructureKey.SupportedCustomLocationFeedClients]: number[];
  [ConfigurationStructureKey.BEBuildMetadata]: BeBuildMetadata;
}

export type USStatesRemote = Record<string, string>;

export type USStates = Array<CLSelectorOption>;
